module.exports = __webpack_public_path__ + "static/media/03-How-To.7bfbbd99.jpg";